import DOMPurify, { Config } from 'dompurify'
import merge from 'lodash/merge'

import domPurifyConfig from '@app/shared/config/dom-purify'

export default (
  str: string | Node,
  config: Config = {}
): string | HTMLElement | DocumentFragment => {
  const effectiveConfig = merge({}, domPurifyConfig, config) as Config

  return DOMPurify.sanitize(str, effectiveConfig)
}
